//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import privacy from './privacy.vue'
	import { Button, Field, Notify, Area, Picker, Toast, Icon} from 'vant';
	import { saveUserInfo, getALlAreaList, sendCode, checkCode, getUserFeedback } from '../../api/index'
	export default {
	name: 'user',
	data () {
	    return {
				showPrivacy:false,
				checked:true,
				show: true,
				name: '',
				phone: '',
				code: '',
				area_code: '',
				area_code_name:'',
				time:60 * 1000,
				send_succ:false,
				area_name:'',
				areaList: {
					province_list: {},
					city_list: {},
					county_list: {}
				},
				show_area:false,
				phone_show: '',
			}
	},
	components:{
		privacy
	},
	props:{
		isShowTip:{
			type: Number,
			default:-1
		},
		exa_id:{
			type: String,
			default:0
		},
		live_id:{
			type: Number,
			default:0
		},
		consult_item:{
			type: Object,
			default:()=>{}
		},
		earnest_item:{
			type: Object,
			default:()=>{}
		}
	},
	methods:{
		closePrivacy(){
			this.showPrivacy = false
		},
		toPrivacy(){
			this.showPrivacy = true
		},
		//value=0改变省，1改变市，2改变区
		onChange(picker, index, value){
			let val = picker.getValues();
			//console.log(val)//查看打印
			let areaName = ''
			for (var i = 0; i < val.length; i++) {
				areaName = areaName+(i==0?'':' / ')+val[i].name
			}
			this.area_name = areaName
		},
		//确定选择城市
		onConfirm(values){
			this.area_name = values.map((item) => item.name).join(' / ');
			this.area_code = values[2].code
			this.area_code_name = values[2].name
			this.show_area = false//关闭弹框
		},
		//取消选中城市
		onCancel(){
			this.show_area = false
			this.$refs.myArea.reset()// 重置城市列表
		},
		finish() {
			this.send_succ = false
		},
		closePopup(){
			// this.$parent.closeUser();
			this.$emit('closeShowUser');
		},
		beforeClose() {
			let _this = this
			if(_this.name == '') {
				Notify({ type: 'danger', message: '请输入姓名', duration: 1500 });
				return
			}
			if(_this.area_code == '') {
				Notify({ type: 'danger', message: '请选择意向区域', duration: 1500 });
				return
			}
			if(_this.phone == '') {
				Notify({ type: 'danger', message: '请输入手机号', duration: 1500 });
				return
			}
			if (_this.phone.length != 11) {
 				Notify({ type: 'danger', message: '手机号格式不正确', duration: 1500 });
 				return
 			}
			if(_this.code == '') {
				Notify({ type: 'danger', message: '请输入验证码', duration: 1500 });
				return
			}
			if(_this.checked == false){
				Notify({ type: 'danger', message: '请阅读并同意云联盟用户隐私协议', duration: 1500 });
				return
			}
			//用户数据提交
			let obj = {}
			obj.name = _this.name
			obj.phone = _this.phone
			obj.code = _this.code
			obj.area_code = _this.area_code
			obj.area_code_name = _this.area_code_name
			obj.openid = localStorage.getItem('openid')
			obj.user_id = localStorage.getItem('user_id')
			obj.exa_id = _this.exa_id
			obj.live_id = _this.live_id
			checkCode(obj).then(res => {
				if (res.code == 0) {
					saveUserInfo(obj).then(res1 => {
						if (res1.code == 0) {
							let area_id = res1.data.area_id
							if(_this.isShowTip == 0){
								let name = _this.name
								_this.$parent.onSubmit(name, area_id);
							}
							if(_this.isShowTip == 1){
								let name = _this.name
								//_this.$emit('showAsk', name, area_id);
								_this.$parent.showAsk(name, area_id);
							}
							if(_this.isShowTip == 2){
								let name = _this.name
								//_this.$emit('joinLive', name, area_id);
								_this.$parent.joinLive(name, area_id);
							}
							if(_this.isShowTip == 3){
								let name = _this.name
								_this.$emit('getName',name, area_id);
								//_this.$emit('showConsult', _this.consult_item);
								_this.$parent.showConsult(name, area_id);
							}
							if(_this.isShowTip == 4){
								let name = _this.name
								_this.$emit('getName',name, area_id);
								//_this.$emit('buyEarnest',_this.earnest_item);
								_this.$parent.buyEarnest(_this.earnest_item, area_id);
							}
							if(_this.isShowTip == 5){
								let name = _this.name
								_this.$parent.trigerClickPhone(name, area_id);
							}
							if(_this.isShowTip == 6){
								let name = _this.name
								_this.$emit('getName',name);
								//_this.$emit('submit', name, area_id);
								_this.$parent.submit(name, area_id);
							}
							if(_this.isShowTip == 7){
								let name = _this.name
								_this.$emit('getName',name);
								//_this.$emit('init');
								_this.$parent.init();
							}
							if(_this.isShowTip == 8){
								let name = _this.name
								_this.$parent.startLuck(_this.name);
							}
							_this.$emit('closeShowUser');
							Notify({ type: 'success', message: '信息提交成功', duration: 1500 });
							return;
							// setTimeout(function() {
							// 	window.location.reload()
							// }, 1500);
						} else {
							Notify({ type: 'danger', message: res1.text, duration: 1500 });
							// done(false)
							return
						}
					})
				} else {
					Notify({ type: 'danger', message: res.text, duration: 1500 });
					return
				}
			})
		},
		sendCode() {
			let _this = this
			if (_this.phone == '') {
				Notify({ type: 'danger', message: '请输入手机号', duration: 1500 });
				return
			}
			if (_this.phone.length != 11) {
 				Notify({ type: 'danger', message: '手机号格式不正确', duration: 1500 });
 				return
 			}
			let obj = {}
			obj.phone = _this.phone
			sendCode(obj).then(res => {
				if (res.code == 0) {
					Notify({ type: 'success', message: '发送成功', duration: 1500 });
					this.send_succ = true
				} else {
					Notify({ type: 'danger', message: res.text, duration: 1500 });
				}
			})
		}
	},
	mounted() {
		let _this = this
		getALlAreaList().then(res => {
			_this.areaList.province_list = res.data.province_list
			_this.areaList.city_list = res.data.city_list
			_this.areaList.county_list = res.data.county_list
		})

		let user_obj = {}
		user_obj.openid = localStorage.getItem('openid')
		getUserFeedback(user_obj).then(res => {
			if (res.code == 0) {
				_this.name = res.user_info.name
				_this.phone = res.user_info.username
				if (res.user_info.username) {
					_this.phone_show = res.user_info.username.substr(0,3) + '****' + res.user_info.username.substr(7)
				}
			}
		})
	}
}



// WEBPACK FOOTER //
// ./src/components/user.vue